import { useODataReadFirstApi } from '@msrceng/component';
import { useEndpointHeader } from './useEndpointHeader';
import { HeaderContent } from 'types';

export const useHeaderReadFirstApi = () => {
  const endpoint = useEndpointHeader();

  return useODataReadFirstApi<HeaderContent>(endpoint);
};
